export const excludeObjectKey = <T extends object, U extends keyof any>(obj: T, key: U) => {
    const { [key]: _, ...newObj } = obj;
    return newObj;
};

export const excludeObjectKeys = <T extends object, U extends readonly (keyof T)[]>(
    obj: T,
    keys: U,
): Omit<T, U[number]> => {
    const newObj = { ...obj };
    for (const key of keys) {
        delete newObj[key];
    }
    return newObj;
};
